export default "__VITE_PUBLIC_ASSET__1cff2e4e__"